export default __webpack_public_path__ + "static/apache-d62ba288de7fec81de554f58cdab533f.png";